import { fork, select } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { logger } from 'utils/logger';
import { exchangeEncryptedNameSaga } from 'features/e2ee/sagas/exchangeEncryptedNameSaga';
import type { User } from 'features/users/types';
import { selectRoomId } from 'features/room/roomSlice';

export function* bulkExchangeEncryptedNameSaga(
  users: User[],
  { rename }: { rename?: boolean } = {}
) {
  const roomId: string = yield select(selectRoomId);

  for (const user of users) {
    try {
      yield fork(
        exchangeEncryptedNameSaga,
        {
          id: user.id,
          roomId,
          e2eePublicKey: user.e2eePublicKey!,
        },
        {
          rename,
        }
      );
    } catch (error) {
      Sentry.captureException(error);
      logger
        .remote({ system: true, capture: 'e2ee' })
        .error(`Name exchange failed with the userId=${user.id}`, error);
    }
  }
}
